<template>
  <div v-if="isBannerShow" :class="['mobile-app-banner', `--${platform}`]">
    <a :href="appLink">
      <div v-if="appIcon" class="mobile-app-banner__store-icon" :style="`background-image: url(${appIcon})`"></div>
      <div v-else class="mobile-app-banner__store-icon">
        <v-icon v-if="platform === 'android'">$google-play</v-icon>
        <v-icon v-if="platform === 'ios'" size="32">$app-store</v-icon>
      </div>
    </a>
    <div>
      <div class="mobile-app-banner__title">{{ $t('constants.useOutApps') }}</div>
      <a :href="appLink"><button class="mobile-app-banner__button">{{ $t('buttons.open') }}</button></a>
    </div>
    <div class="mobile-app-banner__close" @click="isBannerShow = false">
      <v-icon size="18">$close</v-icon>
    </div>
  </div>
</template>

<script>
import externalServicesMixin from '@/common/mixins/externalServicesMixin';

const IOS_PATIENT_APP = 'https://apps.apple.com/us/app/careclix/id1460083225?l';
const ANDROID_PATIENT_APP = 'https://play.google.com/store/apps/details?id=com.careclix.patient.preproduction';

export default {
  name: 'MobileAppBanner',
  mixins: [externalServicesMixin],
  data() {
    return {
      whiteLabel: null,
      platform: null,
      isBannerShow: false,
    };
  },
  computed: {
    appLink() {
      if (this.whiteLabel) {
        if (this.platform === 'ios') return this.whiteLabel.appStoreLink || null;
        if (this.platform === 'android') return this.whiteLabel.googlePlayLink || null;
      }

      if (this.platform === 'ios') return IOS_PATIENT_APP;
      if (this.platform === 'android') return ANDROID_PATIENT_APP;
    },
    appIcon() {
      if (this.whiteLabel && this.whiteLabel.favicon) {
        return this.whiteLabel.favicon;
      }

      return null;
    },
  },
  mounted() {
    this.platform = this.getMobileOperatingSystem();
    this.fetchWhiteLabel();
  },
  methods: {
    fetchWhiteLabel() {
      const domain = window.location.host;

      this.$api.whiteLabel.getWhiteLabel(domain)
        .then(res => {
          this.whiteLabel = res.data.payload;
        })
        .catch(err => {
          console.warn('[MobileAppBanner].fetchWhiteLabel(): ', err);
        })
        .finally(() => {
          this.showBanner();
        });
    },
    showBanner() {
      // need timeout, coz $router doesn't change immedeatly after open pages
      setTimeout(() => {
        const hideBanerOnRoutes = ['PillarForm'];
        const showBannerOnCurrentPage = !hideBanerOnRoutes.includes(this.$route.name);

        // TODO: Remove MGD clinic check when mobile app is released
        if (this.checkClinicOnMyGuardianDoc({ id: this.whiteLabel.clinicId })) {
          this.isBannerShow = false;
        } else if (this.appLink && showBannerOnCurrentPage) {
          this.isBannerShow = true;
        }
      }, 1000);
    },
    getMobileOperatingSystem() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone';
      }

      if (/android/i.test(userAgent)) {
        return 'android';
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'ios';
      }

      return 'unknown';
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-app-banner {
  position: fixed;
  width: 100%;
  z-index: 9999;
  height: 80px;
  display: flex;
  background: white;
  box-shadow: 0px 0px 4px 1px #0000001a;
  align-items: center;
  padding: 8px 16px;
  &__store-icon {
    width: 55px;
    height: 55px;
    background-color: white;
    border-radius: 8px;
    background-repeat: no-repeat;
    background-size: 40px;
    background-position: center;
    box-shadow: 0px 0px 6px 0px #00000024;
    margin-right: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__title {
    font-weight: 500;
    margin-bottom: 3px;
  }
  &__button {
    background: #4db7ea;
    border-radius: 4px;
    border: none;
    color: white;
    height: 32px;
    padding: 3px 15px;
    text-transform: uppercase;
    cursor: pointer;
  }
  &__close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-position: center;
  }
}
</style>
